export const SET_RESULT = 'SET_RESULT';
export const CLEAR_RESULT = 'CLEAR_RESULT';
export const SET_LC_RESULT = 'SET_LC_RESULT';
export const INCREMENT_INCORRECT_QUESTIONS_COUNTER = 'INCREMENT_INCORRECT_QUESTIONS_COUNTER';
export const RESET_INCORRECT_QUESTIONS_COUNTER = 'RESET_INCORRECT_QUESTIONS_COUNTER';

export const setResult = (result) => ({
    type: SET_RESULT,
    result,
});

export const clearResult = (resultId) => ({
    type: CLEAR_RESULT,
    resultId,
});

export const setLCResult = (result, resultIndex) => ({
    type: SET_LC_RESULT,
    result,
    resultIndex
});

export const incrementIncorrectQuestionsCounter = () => ({
    type: INCREMENT_INCORRECT_QUESTIONS_COUNTER,
});

export const resetIncorrectQuestionsCounter = () => ({
    type: RESET_INCORRECT_QUESTIONS_COUNTER,
});
